// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"-yaqM","summary":"_1yWq2"};